import React from "react";
import { Col, FormGroup, Row } from "shards-react";
import AdviceText from "../../../advice-text-component/AdviceText";
import { HelpText, Label } from "./style";

const withLabelAndHelpText = BaseInputComponent => props => {
    const element = (
        <FormGroup key={props.id}>
            <Label>{`${props.label} -`}</Label>
            <HelpText>{props.helptext}</HelpText>
            <AdviceText
                showerror={props.showerror}
                text={props.advicetext}
                color={"#8C0E0E"}
            />
            <Row>
                <Col sm={12} md={6} lg={12}>
                    <BaseInputComponent {...props} />
                </Col>
            </Row>
        </FormGroup>
    );
    return element;
};

export default withLabelAndHelpText;
